export default "__VITE_ASSET__DrvKfH93__"